import { render, staticRenderFns } from "./showSurrenderedWindow.vue?vue&type=template&id=51b3e336&"
import script from "./showSurrenderedWindow.vue?vue&type=script&lang=js&"
export * from "./showSurrenderedWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b3e336')) {
      api.createRecord('51b3e336', component.options)
    } else {
      api.reload('51b3e336', component.options)
    }
    module.hot.accept("./showSurrenderedWindow.vue?vue&type=template&id=51b3e336&", function () {
      api.rerender('51b3e336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/releaseControl/showSurrenderedWindow.vue"
export default component.exports